<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-card
      class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10"
    >
      <v-row justify="center">
        <v-col class="text-left" cols="12" sm="12">
          <header-medium
            :text="$t('DetailsPage.header.workflow')"
          ></header-medium>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ workflow.name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.expires_at")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ expiryDate }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="12" class="text-left">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.description")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.description == ""
                  ? $t("DetailsPage.labels.description_missing")
                  : workflow.description
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="text-left" cols="12" sm="12">
          <header-medium
            :text="$t('DetailsPage.header.initiator')"
          ></header-medium>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.first_name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.initiator_first_name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.last_name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.initiator_last_name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="text-left" cols="12" sm="12">
          <header-medium
            :text="$t('DetailsPage.header.signatory')"
          ></header-medium>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="12">
          <info-alert
            :text="$t('DetailsPage.labels.information_alert')"
            :color="mainColor"
          ></info-alert>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.first_name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.first_name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.last_name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.last_name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.email")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ workflow.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.phone")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ workflow.phone }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row v-if="!mobile" justify="center" dense>
        <v-col cols="6" class="text-left">
          <custom-button
            :text="$t('Navigation.cancel_workflow')"
            color="red"
            @click="cancel()"
          ></custom-button>
        </v-col>
        <v-col cols="6" class="text-right">
          <custom-button
            :text="$t('DetailsPage.labels.confirm_contact')"
            @click="navigate(2)"
          ></custom-button>
        </v-col>
      </v-row>
      <v-row v-if="mobile">
        <v-col cols="12">
          <custom-button
            block
            :text="$t('Navigation.cancel_workflow')"
            color="red"
            @click="cancel()"
          ></custom-button>
        </v-col>
      </v-row>
      <v-row v-if="mobile">
        <v-col cols="12">
          <custom-button
            block
            :text="$t('DetailsPage.labels.confirm_contact')"
            @click="navigate(2)"
          ></custom-button>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import i18n from "@/i18n";
import HeaderMedium from "../../components/ui/text/HeaderMedium";
import CustomButton from "../../components/ui/input/CustomButton";
import InfoAlert from "../../components/ui/other/InfoAlert";
import moment from "moment";
import { log } from "@/helpers/logger";

export default {
  name: "credentials",
  title: i18n.t("DetailsPage.header.workflow"),
  components: {
    HeaderMedium,
    CustomButton,
    InfoAlert,
  },
  data() {
    return {
      stepper_progress: 1,
      workflow: {},
      expiryDate: "",
      initiator: {},
      mainColor: "#1e6668",
      mobile: false,
    };
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
  },
  created() {
    this.$emit("step", 1);
    this.mainColor = this.$vuetify.theme.themes.light.primary;
    this.workflow = this.currentWorkflow;

    if (this.workflow.expires_at == null) {
      this.expiryDate = this.$t("DetailsPage.labels.no_expiry_date");
    } else {
      this.expiryDate = this.formatDate(this.workflow.expires_at);
    }
    this.mobile = this.$vuetify.breakpoint.mdAndDown;
  },
  methods: {
    navigate() {
      this.$store.commit("auth/set_workflow", this.workflow);
      //this.$emit("navigate", val);
      this.$router.push(
        "/workflow/" +
          this.currentWorkflow.workflow_id +
          "/" +
          this.currentWorkflow.signer_id +
          "/documents"
      );
      this.$store.commit("set_loading", true);
      log(
        "MainPage.Credentials.navigate - checked credentials for signer " +
          this.workflow.signer_id,
        "info"
      );
    },
    cancel() {
      this.$emit("refuse", true);
    },
    formatDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
  },
};
</script>
